import axios from "../axios";
// 获取学校列表
export const getSchoolList = (data) => {
  return axios({
    url: "/console/school/pageForCurrentEducation",
    method: "GET",
    data: data,
  });
};

// 添加学校
export const addSchool = (data) => {
  return axios({
    url: "/console/school/save",
    method: "POST",
    data,
  });
};

// 更新学校
export const upadteSchool = (data) => {
  return axios({
    url: "/console/school/update",
    method: "POST",
    data,
  });
};

// 禁用学校
export const chanStatus = (data) => {
  return axios({
    url: "/console/school/switch",
    method: "POST",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/schoolManagement.js